import React from 'react';
import { Loader, LoaderProps } from './view';

const DEFAULT_DELAY = 1000;

export interface DelayedLoaderProps extends LoaderProps {
  delay?: number;
}

export interface DelayedLoaderState {
  isVisible: boolean;
}

export class DelayedLoader extends React.Component<
  DelayedLoaderProps,
  DelayedLoaderState
> {
  static defaultProps: Partial<DelayedLoaderProps> = {
    delay: DEFAULT_DELAY,
  };
  timerId: any = null;
  state = {
    isVisible: false,
  };

  showLoader = () => {
    this.setState({
      isVisible: true,
    });
  };

  constructor(props: DelayedLoaderProps) {
    super(props);

    this.timerId = setTimeout(this.showLoader, props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timerId);
  }

  render() {
    if (!this.state.isVisible) {
      return null;
    }

    const { delay, ...loaderProps } = this.props;

    return <Loader {...loaderProps} />;
  }
}
